import { View } from "@react-pdf/renderer";
import { formatDate } from "../../../../../_src_shared/utils/functions/formatDate";
import PdfBox from "../../components/layout/PdfBox";
import PdfSection from "../../components/layout/PdfSection";
import PdfLabel from "../../components/typography/PdfLabel";
import PdfPrimaryTitle from "../../components/typography/PdfPrimaryTitle";
import PdfValue from "../../components/typography/PdfValue";
import PdfPageBrandedSubmission from "../../pages/PdfPageBrandedSubmission";
import PdfBuilderLogo from "../images/PdfBuilderLogo";
import PdfBuilderWaveImage from "../images/PdfBuilderWaveImage";

const PdfPageBrandedIntro = ({
  title,
  applicationDate,
  applicationFor,
  pageNumber,
  children,
}) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={pageNumber}
      hideLogo
      submittedBy={applicationFor}
      submittedDate={applicationDate}
    >
      <PdfBuilderWaveImage
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          height: "140px",
        }}
      />
      <View
        style={{
          backgroundColor: "#2962ff",
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
          height: "6px",
        }}
      />
      <PdfBox
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PdfSection
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PdfBuilderLogo size={64} />
        </PdfSection>
        <PdfBox
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PdfPrimaryTitle style={{ fontSize: 24, textAlign: "center" }}>
            {title}
          </PdfPrimaryTitle>

          {applicationFor && (
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                marginTop: 12,
                // marginBottom: 8,
              }}
            >
              {/* <PdfLabel>Application For:</PdfLabel> */}
              <PdfLabel>Submitted By:</PdfLabel>
              <PdfValue>{applicationFor}</PdfValue>
            </View>
          )}
          {applicationDate && (
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 12,
                gap: "4px",
              }}
            >
              {/* <PdfLabel>Application Date:</PdfLabel> */}
              <PdfLabel>Submitted On:</PdfLabel>
              <PdfValue>{formatDate(applicationDate)}</PdfValue>
            </View>
          )}
          {children}
        </PdfBox>
      </PdfBox>
    </PdfPageBrandedSubmission>
  );
};

export default PdfPageBrandedIntro;
